const Footer = () => {
    const copyright = String.fromCodePoint(0x000A9)
    return (
        <footer>
            <p className="font-bold text-lg text-orange-600 text-center">Gogobits 2023 {copyright}</p>
            <p className="text-sm text-center mb-4 text-sky-500"> <a href="https://rodalexanderson.com">Website made by Rod Alexanderson</a> </p> 
        </footer>
    )
}

export default Footer